function msFromDate (date) {
  return Math.round((new Date(date).getTime() - new Date().getTime()))
}

export default msFromDate
